import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

export type ToolResolutionType = 'confirmed' | 'cancelled';

export type BuiltTool<T = unknown> = {
	key: MessageAction['key'];
	tool_id: MessageAction['actionId'];
	tool_source: MessageAction['toolSource'];
	invocation_id: MessageAction['invocationId'];
	resolution: {
		type: ToolResolutionType;
	};
	data: {
		human_message_id: string;
		arguments: T | MessageAction['data'];
	};
};

/**
 * Builds the canonical "tool" payload that `sendMessageConfirmedTools` expects
 * from a single `MessageAction` plus a resolution outcome.
 *
 * The optional `args` parameter overrides the default tool arguments. When
 * omitted, the action's existing `data` is forwarded as-is — useful for
 * cancellations and for actions whose inputs do not need user editing.
 */
export const buildToolFromAction = <T = unknown>(
	action: MessageAction,
	resolutionType: ToolResolutionType,
	args?: T,
): BuiltTool<T> => ({
	key: action.key,
	tool_id: action.actionId,
	tool_source: action.toolSource,
	invocation_id: action.invocationId,
	resolution: {
		type: resolutionType,
	},
	data: {
		human_message_id: action.humanMessageId ?? '',
		arguments: args ?? action.data,
	},
});
